import { render, staticRenderFns } from "./EmailTemplateModal.vue?vue&type=template&id=d50b6c54&"
import script from "./EmailTemplateModal.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports